<template>
<div>
  <!-- 슬라이드 메뉴 -->
  <div class="displayBox">
    <!-- <el-carousel :interval="4000" arrow="always" height="100vh"> -->
    <!-- <el-carousel-item> -->
    <!-- <div id="big">
          <p class="big">중랑구 시설관리 공단은
              <br class="mobileBr" /> 시민들의 편의를 위한</p>
          <p class="big">스마트 주차서비스를 운영합니다.</p>
      </div> -->
    <div id="big">
      <p class="big">광명도시공사는
        <br class="mobileBr" /> 시민들의 편의를 위한</p>
      <p class="big">스마트 주차서비스를 운영합니다.</p>
    </div>
    <!-- <p id="centerSub" class="sub">중랑구 시설관리 공단은 정기주차를 위해 41개소의 주차장에</p> -->
    <p id="centerSub" class="sub">광명도시공사는 정기주차를 위해 15개소의 주차장에</p>
    <p id="centerSub" class="sub">정기 주차 서비스를 운영하고 있습니다.</p>
    <!-- </el-carousel-item> -->
    <!-- </el-carousel> -->
  </div>

  <!-- 빠른 이동 -->
  <div class="redirect-box">
    <div class="redirect-wrapper oneStepBlue" @click="redirectButtonRouterInfo('carSet')">
      <img class="img" src="../../components/image/그룹 18676.png" />

      <div class="redirect-text">차량등록</div>
    </div>

    <div class="redirect-wrapper twoStepBlue" @click="redirectButtonRouterInfo('discountSet')">
      <img class="img" src="../../components/image/그룹 18677.png" />

      <div class="redirect-text">할인등록</div>
    </div>

    <div class="redirect-wrapper thirdStepBlue" @click="redirectButtonRouterInfo('payment')">
      <img class="img" src="../../components/image/그룹 18678.png" />

      <div class="redirect-text">요금납부</div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  methods: {
    redirectButtonRouterInfo(type) {
      if(this.$store.state.isLogin == false) {
        alert('로그인이 필요한 서비스입니다.')
        this.$router.push({name: '로그인'})
        
        return
      }

      if (type === 'carSet') {
        this.$router.push({
          name: '차량 등록 관리',
          query: {
            select: 'total'
          }
        })

        this.$store.isActive = false
        this.$store.isSubmit = false
        this.$store.isCheck = true
      } else if (type == 'discountSet') {

        this.$router.push({
          name: '차량 할인 관리',
          query: {
            select: 'carDiscount'
          }
        })

        this.$store.isActive = false
        this.$store.isSubmit = false
        this.$store.isCheck = true

      } else if (type == 'payment') {
        if (this.$store.state.isAdmin == false) {
          this.$router.push({
            name: '정기권 사용 내역',
            query: {
              select: 'checkUse'
            }
          })

          this.$store.isActive = true
          this.$store.isSubmit = false
          this.$store.isCheck = false

        } else {
          alert('관리자가 이용할 수 없는 기능입니다.')
        }
      }
    }
  }
}
</script>

<style scoped>
@import '@/assets/css/reset.css';

.mobileBr {
  display: none;
}

.displayBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* margin: auto; */
  text-align: center;
  /* max-width: 1200px !important;
        width: 90vw; */
  height: auto;
  margin-top: 5%;
}

/* 바로가기 아이콘 */
.redirect-box {
  display: flex;
  justify-content: center;
  margin: auto;
  text-align: center;
  max-width: 1200px !important;
  width: 90vw;
  height: auto;
  margin-top: 5%;
}

.redirect-wrapper {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: 2%;
  margin-right: 2%;
}

.redirect-wrapper:last-child {
  margin-right: 0;
}

.redirect-text {
  font: normal normal 500 20px/29px Noto Sans KR;
  letter-spacing: 0px;
  color: #FFFFFF;
}

.oneStepBlue {
  background-color: #35A6D0;
}

.twoStepBlue {
  background-color: #358ED0;
}

.thirdStepBlue {
  background-color: #266CB5;
}

/* 글자 크기 */
#big {
  width: 100%;
  height: auto;
  margin-top: 5%;
  margin-bottom: 2%;
  text-align: center;
}

.big {
  text-align: center;
  font: normal normal 500 40px/58px Noto Sans KR;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-shadow: 0px 3px 6px #00000059;
}

.sub {
  text-align: center;
  font: normal normal 300 26px/37px Noto Sans KR;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-shadow: 0px 3px 6px #00000059;
}

/* 전체적인 슬라이드 위치와 크기 */
.el-carousel {
  background-color: transparent !important;
  height: 100vh;
  max-width: 1200px;
  width: 90vw;
  margin-top: 10vh;
}

/* 이미지 크기 */
.el-carousel__item {
  margin-top: 36vh;
  height: auto;
  width: 100%;
  overflow: auto;
}

.el-carousel__container {
  height: auto;
  align-items: center;
  overflow: auto;
}

/* 하단의 슬라이드 아이콘 위치 결정 */
/* .el-carousel >>> .el-carousel__indicators--horizontal {
        margin-bottom: 10%;
    } */

.el-carousel>>>.el-carousel--horizontal {
  height: 1200px;
  padding-top: 600px;
}

/* el-carousel button icon 부분 */
div>>>.el-carousel__arrow--left {
  font-size: 5em;
  background: transparent;
  /* font: inherit !important; */
}

div>>>.el-carousel__arrow--left i {
  font: inherit !important;
}

div>>>.el-carousel__arrow--left:hover {
  color: #475669;
}

div>>>.el-icon-arrow-left:before {
  content: "\276E";
}

div>>>.el-carousel__arrow--right {
  font-size: 5em;
  background: none;
}

div>>>.el-carousel__arrow--right i {
  font: inherit !important;
}

div>>>.el-carousel__arrow--right:hover {
  color: #475669;
}

div>>>.el-icon-arrow-right:before {
  content: "\276F";
}

div>>>.el-carousel__button {
  content: "\2022";
}

/*이미지 삽입부분*/
.el-carousel__item h3 {
  font-size: 18px;
  color: #475669;
  opacity: 0.75;
  line-height: 400px;
  margin: 0;
  text-align: center;
}

/* 반응형 웹 CSS */
@media all and (max-width: 1200px) {
  .el-carousel {
    margin-right: 0 !important;
  }
}

@media all and (max-width: 1024px) {

  .el-carousel {
    float: left;
    width: 1024px;
    margin-right: 0 !important;
  }

  #big {
    margin-top: 4%;
  }

  .big {
    font: normal normal 500 35px/58px Noto Sans KR;
  }

  .sub {
    font: normal normal 300 25px/37px Noto Sans KR;
  }

  div>>>.el-carousel__arrow {
    height: fit-content;
    width: fit-content;
  }

  div>>>.el-carousel__arrow--right {
    left: 86vw;
  }
}

@media all and (max-width: 960px) {

  .big {
    font: normal normal 20px/50px Noto Sans KR-BOLD;
  }

  .sub {
    font: normal normal 300 15px/37px Noto Sans KR;
  }

  .el-carousel__item {
    width: 100vw;
  }

  div>>>.el-carousel__arrow--left {
    font: normal normal 100 3em/50px Noto Sans KR;
    background: transparent;
    left: 8vw;
    /* display: none;  */
    /* 임시 */
  }

  div>>>.el-carousel__arrow--right {
    font: normal normal 100 3em/50px Noto Sans KR;
    /* display: none; */
    left: 81vw;
    /* 임시 */
  }

}

/* 모바일 버전 기본 */
@media all and (max-width: 768px) {

  .displayBox {
    margin-top: 27%;
    margin-bottom: 10%;
  }

  .el-carousel {
    float: left;
    width: 100vw;
    height: 100vh;
    margin-right: 0 !important;
    margin-top: 0;
  }

  .el-carousel>>>.el-carousel__container {
    height: auto !important;
  }

  div>>>.el-carousel__arrow--left {
    font: normal normal 100 3em/50px Noto Sans KR;
    background: transparent;
    display: none;
    /* 임시 */
  }

  div>>>.el-carousel__arrow--right {
    font: normal normal 100 3em/50px Noto Sans KR;
    display: none;
    /* 임시 */
  }

  #big {
    margin-bottom: 5vh;
  }

  .big {
    font: normal normal 24px/29px Noto Sans KR-BOLD;
  }

  .mobileBr {
    display: block;
  }

  .sub {
    font: normal normal 100 16px/21px Noto Sans KR;
  }

  /* 바로가기 */
  .redirect-box {
    flex-direction: column;
    margin-bottom: 13%;
  }

  .redirect-wrapper {
    display: flex;
    align-items: center;
    margin-right: 0;
    margin-bottom: 5%;
    padding: 5%;
  }

  /* .redirect-wrapper:last-child {
            margin-bottom: 0;
        } */

  .redirect-wrapper>>>img {
    display: none;
  }

  .redirect-text {
    width: 80%;
    /* width: 20vw; */
    font-size: 18px;
    border-radius: 10px;
    background-color: #fff;
    padding: 2%;
  }

  .oneStepBlue>>>.redirect-text {
    color: #35A6D0;
  }

  .twoStepBlue>>>.redirect-text {
    color: #358ED0;
  }

  .thirdStepBlue>>>.redirect-text {
    color: #266CB5;
  }

}

@media all and (max-width: 486px) {

  .el-carousel__item {
    margin-top: 50%
  }

  .el-carousel {
    left: -18px;
  }

}

/* 높이 반응형 css */

@media all and (min-height: 1400px) {

  .el-carousel::v-deep .el-carousel__container {
    height: 90vh !important;
  }

}

@media all and (max-height: 530px) {

  .sub {
    display: none;
  }

}

@media all and (max-height: 464px) {

  .el-carousel__container {
    height: 80vh !important;
  }

  .el-carousel__item {
    margin-top: 25vh;
  }

}
</style>
